import { EffectItem } from './effectItem.model';

export class CrewEffects {
  private readonly data: {
    crewMemberId: string;
    docType: string;
    items: {
      [key: string]: number;
    };
    lastUpdateSource: string;
    lastUpdated: string;
  };

  constructor(data: any, private readonly effectItems: Array<EffectItem>) {
    this.data = data;
  }

  public get items(): Array<{
    item: EffectItem;
    amount: number;
  }> {
    if (!this.data.items) return [];
    const items = Object.keys(this.data.items);
    return this.effectItems
      .filter(item => items.includes(item.code))
      .map(item => ({
        item,
        amount: this.data.items[item.code] || 0,
      }));
  }
}
